const vastErrors = {
    NONE: '',
    EMPTY: 'empty',
    INVALID: 'invalid',
    UNEXPECTED: 'undexpected',
};

export default vastErrors;
